var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5054 7.27259C14.2359 4.8351 12.6278 2.80092 10.4326 1.92135C11.1185 3.24501 11.5439 5.1446 11.6231 7.27259H14.5054ZM14.5054 8.72704H11.6231C11.5439 10.8548 11.1185 12.7543 10.4326 14.078C12.6278 13.1988 14.2359 11.1645 14.5054 8.72704ZM1.49446 7.27259H4.37705C4.45618 5.1446 4.88159 3.24507 5.5673 1.92135C3.37211 2.80086 1.76401 4.8351 1.49446 7.27259ZM1.49446 8.72704C1.76402 11.1645 3.37211 13.1987 5.5673 14.078C4.8816 12.7544 4.45621 10.8548 4.37705 8.72704H1.49446ZM10.1661 7.27259C10.0256 3.97485 8.95301 1.45432 7.99969 1.45432C7.04637 1.45432 5.97374 3.97485 5.83348 7.27259H10.1661ZM5.83348 8.72704C5.97374 12.0248 7.04637 14.5451 7.99969 14.5451C8.95301 14.5451 10.0256 12.0248 10.1661 8.72704H5.83348ZM16 7.99969C16 12.4178 12.4181 16 7.99969 16C3.58181 16 0 12.4181 0 7.99969C0 3.58181 3.58194 0 7.99969 0C12.4178 0 16 3.58194 16 7.99969Z",
    fill: "#D2D2D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.e9b61bf3.svg";
export { ForwardRef as ReactComponent };